<template>
  <div>
    <div
      class="d-flex flex-column p-6 bgi-size-cover bgi-no-repeat rounded bg-primary"
    >
      <h4 class="d-flex flex-center rounded-top">
        <span class="text-white">Perjanjian yang baru diajukan</span>
        <span
          class="btn btn-text btn-warning btn-sm font-weight-bold btn-font-md ml-2"
        >
          {{appointment_submission}}
        </span>
      </h4>
    </div>
  </div>
</template>

<style lang="scss">
/* hide default vue-bootstrap tab links */
.hide-tabs > div:not(.tab-content) {
  display: none;
}
</style>

<script>
export default {
  name: "WMReportNotification",
  props:["appointment_submission"],
};
</script>
